import * as actions from "./actions";
import { getHeaders, http } from "../utils";
import { setTimeout } from "timers";

export function getDashboardInfo(dispatch: any) {
	return function () {
		dispatch(actions.getDashboardInfoStart());
		return http
			.get(`recipient_dashboard`)
			.then((data: any) => {
				dispatch(actions.getDashboardInfoSuccess(data.data));
				return data;
			})
			.catch((err: any) => {
				if (err.message === "Request failed with status code 401") {
					getDashboardInfo(dispatch);
				}
				dispatch(actions.getDashboardInfoError(err));
				return err;
			});
	};
}
export function updateRecipient(dispatch: any) {
	return function (data: any) {
		dispatch(actions.updateRecipientStart());
		return http
			.post(`update-recipient`, data)
			.then((data: any) => {
				dispatch(actions.updateRecipientSuccess(data.data));
				return data;
			})
			.catch((err: any) => {
				if (err.message === "Request failed with status code 401") {
					updateRecipient(dispatch);
				}
				dispatch(actions.updateRecipientError(err));
				return err;
			});
	};
}
export function getCertificates(dispatch: any) {
	return function () {
		dispatch(actions.getCertificatesStart());
		return http
			.get(`credentials`)
			.then((data: any) => {
				dispatch(actions.getCertificatesSuccess(data.data.certificates));
				return data;
			})
			.catch((err: any) => {
				if (err.message === "Request failed with status code 401") {
					getCertificates(dispatch);
				}
				dispatch(actions.getCertificatesError(err));
				return err;
			});
	};
}

// export function getCommunications(dispatch: any) {
//   return function () {
//     dispatch(actions.getCommunicationsStart());
//     return http.get(`recipient_communications`)
//       .then((data: any) => {
//         dispatch(actions.getCommunicationsSuccess(data.data.communications[1]));
//         return data;
//       })
//       .catch((err: any) => {
//         if (err.message === "Request failed with status code 401") {
//           getCommunications(dispatch);
//         }
//         dispatch(actions.getCommunicationsError(err));
//         return err;
//       })
//   };
// }

export function setWizzardActiveStep(dispatch: any) {
	return function (step: any) {
		dispatch(actions.setWizzardActiveStep(step));
	};
}

// export function addToast(toast: any) {
//   return function(dispatch: any) {
//     dispatch(actions.addToast(toast))
//   }
// }

let id = 0;
const defaultOptions = {
	color: "#6796e6",
};
export default function createToast(options: any) {
	return {
		...defaultOptions,
		...options,
		id: id++,
	};
}

export function addToast(dispatch: any) {
	return function (toast: any) {
		const newToast = createToast(toast);

		dispatch(actions.addToast(newToast));
		setTimeout(() => {
			dispatch(actions.removeToast(newToast.id));
		}, 5000);
	};
}

export function removeToast(dispatch: any) {
	return function (toast: any) {
		dispatch(actions.removeToast(toast));
	};
}
